<template>
  <div class="user-details">
    <menu-list :is-opened="isOpened" @logout="logout" class="is-hidden-mobile"></menu-list>
    <a class="user-item" :class="{active: isOpened}" aria-expanded="true" @click="toggleUserActions()">
      <name-acronym v-if="fullName" :full-name="fullName" class="acronym"></name-acronym>
      <span>
        <span v-if="fullName" class="username">{{fullName | fullname}}</span>
        <span class="fa fa-angle-down menu-icon is-angle"></span>
      </span>
    </a>
    <menu-list :is-opened="isOpened" @logout="logout" class="is-hidden-tablet"></menu-list>
  </div>
</template>

<script>
  import NameAcronym from "../../../NameAcronym";
  import MenuList from "./MenuList";

  export default {
    props: ['fullName', 'isOpened'],
    components: {NameAcronym, MenuList},
    methods: {
      logout() {
        this.$emit('close')
        this.$auth.logout({
          redirect: 'Login',
          makeRequest: false // TODO: check
        })
      },
      toggleUserActions() {
        this.$emit('toggle')
      },
    }
  }
</script>

<style lang="scss">
  @import "../../../../../node_modules/bulma/sass/utilities/mixins";
  @import "../../../../../sass/fct/variables";

  .menu-list, .user-details {
    position: relative;
    z-index: 50;
  }

  .menu-list > ul {
    ul {
      border-left: none !important;

      > li {
        font-weight: 500;
      }
    }
  }

  .user-item {
    display: inline-block;
    @include tablet() {
      margin-left: 30px;
    }

    @include mobile() {
      display: flex;
      align-items: flex-start;
      flex-direction: column;
      margin-top: 20px;

      > span {
        @include mobile() {
          margin-top: 15px;
          margin-bottom: 12px;
        }
      }
    }

    color: #fff !important;

    .acronym {
      @include tablet() {
        transform: translateY(-10px);
      }
    }

    .username {
      padding: 0 10px;
      text-transform: capitalize;
      color: #fff;
      font-family: montserratsemibold;
      font-size: 12px;
      display: inline-block;
    }

    .menu-icon {
      transform: translateY(4px);
      transform-origin: center center;
      transition: 0.86s;
    }

    &.active {
      color: $active-color;

      .menu-icon {
        transform: rotate(180deg) translateY(-3px);
      }
    }
  }

  .user-details {
    @include tablet() {
      position: absolute;
      bottom: 50px;
    }

    @include mobile() {
      padding-left: 30px;
      display: inline-block;
      width: 100%;
      background: url("../../../../assets/sidebar_bg_mobile.svg");
      background-size: cover;
      padding-bottom: 15px;
      min-height: 180px;
    }

    width: 100%;

    ul.user-actions {
      margin-top: 0px !important;
      margin-bottom: 0px !important;
      border: none;

      @include mobile() {

        a {
          color: #fff !important;
          &:hover {
            background-color: rgba(#333, 0.1) !important;
          }
        }
      }

      transition: height 0.86s;

      @include mobile() {
        transition: height 0.46s;
      }
      overflow: hidden !important;

      li {
        a {
          line-height: 1.6;
          color: $default-color;

          &:hover {
            color: #fff;
          }
        }
      }
    }

    .menu-list {
      @include mobile() {
        padding-top: 0 !important;
      }
      > ul {
        @include tablet() {
          position: absolute;
          width: 100%;
          bottom: -10px;
        }

        ul {
          margin: 0;
          padding: 0;

          @include mobile() {
            transform: translateX(-16px);
            transform: translateX(-16px);
          }

          &.user-actions-open {
            height: 120px;

            @include mobile() {
              height: 90px;
            }

            a {
              margin: 0 10px;
              height: 38px;
              @include tablet() {
                background-color: rgba(20, 30, 30, 0.2);
                transition-delay: 0.86s;
              }

              transition-property: background-color;

              &.active {
                background-color: rgba(20, 30, 30, 0.5);
              }
            }
          }

          &.user-actions-close {
            height: 0px;
          }

          > li {
            margin: 5px 0;
          }

          li {
            a {
              margin: 0 20px;
              padding-left: 50px;
              /*width: 100%;*/
              text-align: left;
              border-radius: 20px;
              color: #90a5c2;

              @include mobile() {
                > span.icon.is-small {
                  color: #fff;
                }
              }

              &:hover {
                > span.icon.is-small {
                  color: #fff;
                }
              }

              &.active {
                color: #fff !important;
              }
            }
          }
        }
      }
    }
  }
</style>
